import BulbPreload from '../core/bulbPreload';
import gsap from 'gsap'
/**
 * Main loader qui s'initialise lors du once de barba js
 */
class SiteLoader {

    constructor() {
        this.bulbPreload = new BulbPreload()
        this.pageLoader = document.querySelector('.siteLoader')
        this.bulbPreload.on('progress', this.progressLoading.bind(this))
        this.bulbPreload.on('done', this.closeTransition.bind(this))
    }

    preloadAsset() {
        let images = document.querySelectorAll('img[data-bulb-preload]');
        this.bulbPreload.loadImages(images)
    }

    closeTransition(){
        console.log('SiteLoader : close transition')
        gsap.to(this.pageLoader, {duration: 1, opacity: 0})
    }

    progressLoading(objPercent) {
        console.log('SiteLoader : progressLoading : ' + objPercent)
    }
}

//module.exports = SiteLoader;
export default SiteLoader;



// WEBPACK FOOTER //
// ./scripts/interface/siteLoader.js